import axios from 'axios';
import { Notify } from 'quasar';

export async function init({ commit, dispatch }) {
	await dispatch('getUser');
	commit('INIT');
}

export async function register(context, { email, password }) {
	try {
		await axios.post('/user', { email, password });
	} catch (error) {
		if (!error.handled) {
			if (error.response.status === 409) {
				throw error;
			}
			console.error(error);
			Notify.error('Ein unerwarteter Fehler ist aufgetreten!');
		}
	}
}

export async function login({ commit }, { email, password }) {
	try {
		const { data } = await axios.post('/auth/login', { email, password });
		const { accessToken, user } = data;
		commit('SET_ACCESS_TOKEN', accessToken);
		commit('SET_CURRENT_USER', user);
		Notify.removeAll();
	} catch (error) {
		if (!error.handled) {
			if (error.response.status === 404 || error.response.status === 400) {
				throw error;
			}
			console.error(error);
			Notify.error('Ein unerwarteter Fehler ist aufgetreten!');
		}
	}
}

let refreshTokenRequest = null;
export async function refreshToken({ commit }) {
	if (refreshTokenRequest) {
		await refreshTokenRequest;
		return;
	}

	refreshTokenRequest = axios.get('/auth/refreshToken', {
		validateStatus: status => status < 500,
	});

	const res = await refreshTokenRequest;
	refreshTokenRequest = null;

	const accessToken = res.status < 300 ? res.data.accessToken : null;
	commit('SET_ACCESS_TOKEN', accessToken);

	if (!accessToken) {
		Notify.error(
			'Ihre Sitzung ist abgelaufen, bitte loggen Sie sich erneut ein!'
		);
		this.$router.push('/login');
	}
}

export async function requestPassword(context, { email }) {
	try {
		await axios.post('/user/password/request', { email });
	} catch (error) {
		if (!error.handled) {
			if (error.response.status === 404) {
				throw error;
			}
			console.error(error);
			Notify.error('Ein unerwarteter Fehler ist aufgetreten!');
		}
	}
}

export async function resetPassword(context, { resetKey, password }) {
	try {
		await axios.post('/user/password/reset', { resetKey, password });
	} catch (error) {
		if (!error.handled) {
			if (error.response.status === 400) {
				throw error;
			}
			console.error(error);
			Notify.error('Ein unerwarteter Fehler ist aufgetreten!');
		}
	}
}

export function logout({ commit, dispatch }) {
	commit('RESET');
	dispatch('admin/reset', null, { root: true });
	Notify.removeAll();
}

export async function updateUser({ commit, rootState }, user) {
	user = Object.assign({}, user);
	delete user.ID;
	delete user.email;
	delete user.upgrade;
	delete user.product;
	const { data } = await axios.put('/user', user);
	if (rootState.admin.loggedInAs) {
		data.isAdmin = true;
	}
	commit('SET_CURRENT_USER', data);
}

export async function getUser({ commit, rootState }) {
	const { data } = await axios.get('/user');
	if (rootState.admin.loggedInAs) {
		data.isAdmin = true;
	}
	commit('SET_CURRENT_USER', data);
}
